import { Link, type LinkProps } from "@tanstack/react-router";
import * as React from "react";

import { SMART_ACTION_SHADOW_PARAM } from "./smart-action-shadow-search";

type Props = {
  smartActionId: string;
  children: React.ReactNode;
  className?: string;
} & Omit<LinkProps, "to" | "search" | "className">;

/**
 * Opens a Smart Action's popup over the current page: it stays on the route
 * (`to="."`) and adds `?smartActionId=<id>`, so the order or report underneath
 * stays as it was, and closing the popup comes back to it. The route must
 * declare the key (`smartActionShadowSearchFragment`).
 */
export const SmartActionLink = React.forwardRef<
  React.ElementRef<typeof Link>,
  Props
>(function SmartActionLink(
  { smartActionId, children, className, ...rest },
  ref,
) {
  return (
    <Link
      ref={ref}
      {...(rest as LinkProps)}
      to={"." as LinkProps["to"]}
      search={(prev: Record<string, unknown>) => ({
        ...prev,
        [SMART_ACTION_SHADOW_PARAM]: smartActionId,
      })}
      {...(className ? { className } : {})}
    >
      {children}
    </Link>
  );
});
